import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HeimtierKalenderEintrag } from '../../kalender/heimtier-kalender-eintrag';

@Component({
    selector: 'kiene-heimtier-bezahlung-dialog',
    templateUrl: './heimtier-bezahlung-dialog.component.html',
    styleUrls: ['./heimtier-bezahlung-dialog.component.scss'],
})
export class HeimtierBezahlungDialogComponent {
    isSaving = false;
    methode: string;

    constructor(
        public dialogRef: MatDialogRef<HeimtierBezahlungDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public kalenderEintrag: HeimtierKalenderEintrag,
    ) {}

    public cancel(): void {
        this.dialogRef.close();
    }

    public save(): void {
        this.dialogRef.close(this.methode);
    }
}
